function Album() {
  return (
    <div>
      <h2 className="titulos">Livros</h2>
      <div className="album py-sm-0 bg-light">
        <div className="container-fluid mb-2">
          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
            <div className="col">
              <div className="shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/livro1.png"
                  alt="livro 1"
                  />
              </div>
            </div>
            <div className="col">
              <div className="shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/livro.jpg"
                  alt="livro 2"
                />
              </div>
            </div>
            <div className="col">
              <div className="shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/livro2.png"
                  alt="livro 3" 
                />
              </div>
            </div>

            <div className="col">
              <div className="shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/livro3.png"
                  alt="livro 4"
                />
              </div>
            </div>
            <div className="col">
              <div className="shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/livro4.jpg"
                  alt="livro 5"
                  
                />
              </div>
            </div>
            <div className="col">
              <div className="shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/livro5.jpg"
                  alt="livro 6"
                />
              </div>
            </div>

            <div className="col">
              <div className="shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/livro6.jpg"
                  alt="livro 7"
                />
              </div>
            </div>
            <div className="col">
              <div className="shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/livro7.jpg"
                  alt="livro 8"
                  />
              </div>
            </div>
            <div className="col">
              <div className="shadow-sm photo-album">
                <img
                  className="bd-placeholder-img card-img-top"
                  width="100%"
                  height="225"
                  src="./img/livro8.jpg"
                  alt="livro 9"
                 />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Album;
